const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/reports/api-factory');
const serviceFactory = require('../resources/reports/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/reports/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app

//get daily statements
  .match(`${p}dailyStatements.getData[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:outputType}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getDailyStatementsData(req.params)
      .then(response => res.value(response))
      .catch(res.error)
   )))
//get Monthly Statements
  .match(`${p}monthlyStatements.getData[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:outputType}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
      service.getMonthlyStatementsData(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))

//get transaction history details
  .match(`${p}transactions.getData[{keys:portfolioId}][{keys:startDate}][{keys:endDate}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getTransactionHistoryData(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))

//get last month Statements
  .match(`${p}reports.getLastStatements[{keys:portfolioId}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getLastStatementsData(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))

  .match(`${p}monthly.getMonthStatement[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:outputType}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
      service.getMonthStatement(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))

  .match(`${p}daily.getPdfLists[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:outputType}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    service.getPdfLists(req.params)
      .then(response => res.value(response))
      .catch(res.error)
   )))

  .match(`${p}transactAdvice.getTransactionAdvices[{keys:portfolioId}][{integers:tradeNo}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
       service.getTransactionAdvices(req.params.portfolioId, req.params.tradeNo, req.params.metaData)
        .then(response => res.value(response))
        .catch(res.error)
      )))

  .match(`${p}monthly.getPdf[{keys:accountId}][{keys:docId}]`, requests => Promise.all(
   requests.map(({ req, res }) =>
    {
      if (req.params.accountId) req.params.accountId = req.params.accountId.slice(4);
      if (req.params.docId) req.params.docId = req.params.docId.replace('<<<dot>>>', '.');

      return service.getPdfStatement(req.params)
        .then(response => res.value(response.data))
        .catch(res.error)
    }
  )))

  //get transaction history details for chdelivery
  .match(`${p}edelivery.transactions.getData[{keys:portfolioId}][{keys:startDate}][{keys:endDate}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
     service.getTransactionHistoryDataForEdeliveryApp(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))
    //Channel parameter added for web need to make changes during app  release
  .match(`${p}edelivery.transactions.getTransactionsData[{keys:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:channel}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
      service.getTransactionHistoryDataForEdelivery(req.params)
        .then(response => res.value(response))
        .catch(res.error)
      )))
      
  //WMCE-4443, IMPLEMENTING INTEGER VALUE FOR BP IDS.
  .match(`${p}edelivery.transactions.getData[{integers:portfolioId}][{keys:startDate}][{keys:endDate}]`, requests => Promise.all(
    requests.map(({ req, res }) => 
     service.getTransactionHistoryDataForEdeliveryApp(req.params)
      .then(response => res.value(response))
      .catch(res.error)
    )))
    
  .match(`${p}edelivery.transactions.getTransactionsData[{integers:portfolioId}][{keys:startDate}][{keys:endDate}][{keys:channel}]`, requests => Promise.all(
    requests.map(({ req, res }) => 
      service.getTransactionHistoryDataForEdelivery(req.params)
        .then(response => res.value(response))
        .catch(res.error)
      )));
}

module.exports = addRoutes;
